import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function LezIndivAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "40%"}}>
                                        5 lezioni
                                    </th>
                                    <th scope="col" style={{width: "40%"}}>
                                        10 lezioni
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <td></td>
                                    <th colSpan={2} scope="row">Lezioni da 30 minuti</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Singole</th>
                                    <td className={"data-cell"}>100 €</td>
                                    <td className={"data-cell"}>180 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Di coppia <br/> <span style={{fontSize: "10px"}}>(prezzo per persona)</span></th>
                                    <td className={"data-cell"}>75 €</td>
                                    <td className={"data-cell"}>135 €</td>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <td></td>
                                    <th colSpan={2} scope="row">Lezioni da 45 minuti</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Singole</th>
                                    <td className={"data-cell"}>150 €</td>
                                    <td className={"data-cell"}>270 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Di coppia <br/> <span style={{fontSize: "10px"}}>(prezzo per persona)</span></th>
                                    <td className={"data-cell"}>112,5 €</td>
                                    <td className={"data-cell"}>202,5 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LezIndivAccordionPrezzi